import Cookies from 'js-cookie';
import React, { useContext, useEffect, useState } from 'react';
import { AdminContext } from '../../context/AdminContext';
import CookieFunction from '../../functions/cookieFunction';
import AppIcons from '../../icons';
import findLanguageList from '../../objects/findLanguageList';
import languages from '../../objects/languages';
// import { AdminContext } from '../../../context/AdminContext';
import Checkbox from '../CheckBox';
import styles from './styles.module.scss';

const LanguageBox = ({
  onClickLang = () => console.log('theme'),
  extraClassName = 'nothing',
}) => {
  const {
    themeColor,
    direction,
    setDirection,
    content,
    setContent,
    lang,
    setLang,
    themeMode,
  } = useContext(AdminContext);
  const [activeLang, setActiveLang] = useState(findLanguageList(lang));

  // useEffect(() => {
  //   setActiveLang(findLanguageList(lang));
  // }, [lang]);

  const changeActiveLanguage = (x) => {
    // Cookies.set('ochattLang', x, {
    //   expires: 365,
    // });
    // localStorage.setItem('ochattLang', x);
    CookieFunction('set', 'ochattLang', x, () => {
      setLang(CookieFunction('get', 'ochattLang'));
      setActiveLang(CookieFunction('get', 'ochattLang'));
    });
    setActiveLang(findLanguageList(x));
    setLang(x);
    // setActiveLang(languages[languages?.findIndex((x) => x.code == x)]);
    // // setLang(Cookies.get('ochattLang'));
    // setLang(localStorage.getItem('ochattLang'));
    // // setActiveLang(Cookies.get('clipshoLnag'));
    // setActiveLang(localStorage.getItem('ochattLang'));
    // setShowProfileMenu(false);
  };

  console.log('languageArray', languages, activeLang);
  return (
    <div className={`${styles.ProfileMenuMiddle} noBorder `}>
      {/* <p>{content?.toolbar?.language?.title}</p> */}
      <div
        className={`flex flex-col justify-start items-start w-full ${extraClassName}`}
      >
        {activeLang?.array?.map((item, index) => (
          <div
            className={`flex flex-row justify-between w-full items-center my-[8px] mx-[2px] cursor-pointer ${styles.singleItem}`}
            onClick={() => {
              // setLang(item?.code);
              changeActiveLanguage(item?.code);
            }}
            key={index}
          >
            <div className={`mx-8px ${themeMode != 'white' && 'textWhite'}`}>
              {item?.text}
            </div>
            <div
              className={`${
                styles.color
              } bg-white-theme flex justify-center items-center ${` ${styles.unActive} checkboxCircle`}`}
            >
              {lang == item?.code && (
                <AppIcons.checkIcon width={8} height={11} />
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LanguageBox;
